<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="offer manage">
          <div class="custom"/>
          <div class="options">
            <el-form :model="searchData" inline>
              <jm-form-options :options="searchStructure" :option-data="searchData" :const-dict="options"/>
            </el-form>
          </div>
          <div class="operation">
            <el-button type="primary" :size="size" @click="getSearch">查询</el-button>
            <el-button type="primary" :size="size" @click="setSearchData">重置</el-button>
          </div>
          <el-row class="rows" :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">创建人占比</span>
                </p>
                <div class="chart-div">
                  <bi-d-pie :data="createrData.data" :options="createrData.options" :refresh="createrData.refresh" @reload="getCreater"/>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <div class="rows-div">
                <p>
                  <span class="s_title">行为和创建人趋势</span>
                  <el-tooltip
                    placement="top"
                    effect="light">
                    <div slot="content">
                      数据量过多时，可以使用鼠标左右拖动下方数据区域
                    </div>
                    <span><i class="el-icon-caret-left blue"/><i class="el-icon-caret-right blue"/></span>
                  </el-tooltip>
                </p>
                <div class="chart-div">
                  <bi-bar-line
                    :data="actionData.data"
                    :data1="actionData.data1"
                    :options="actionData.options"
                    :refresh="actionData.refresh"
                    @reload="getActionData"/>
                </div>
              </div>
            </el-col>
          </el-row>
          <jm-tableList
            url="/index/b_i_action_group/getUserPage" :search-data="searchData" :refresh.sync="searchData.isSearch" :current-page.sync="currentPage">
            <el-table-column slot="custom_name" slot-scope="scope" v-bind="scope.attrs" :label="scope.label" property="custom_name">
              <template slot-scope="scope">
                {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
              </template>
            </el-table-column>
            <el-table-column slot="crm_sayer" slot-scope="scope" v-bind="scope.attrs" :label="scope.label" property="crm_sayer">
              <template slot-scope="scope">
                <a href="javascript:void();">{{ scope.row.crm_role }}</a><br>
                <span>{{ scope.row.crm_sayer_name }}</span>
              </template>
            </el-table-column>
            <el-table-column slot="crm_level_lv" slot-scope="scope" v-bind="scope.attrs" :label="scope.label" property="crm_level_lv">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.crm_level_lv" :type="getResourceTag(scope.row.lv)">
                  {{ scope.row.crm_level_lv }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column slot="userid" slot-scope="scope" v-bind="scope.attrs" :label="scope.label" property="userid">
              <template slot-scope="scope">
                {{ scope.row.count_action }}
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BiDPie from '@/components/charts/biDPie';
import BiBarLine from '@/components/charts/biBarLine';
import common from '@/pages/bi/common';
import student from '@/pages/student/student';
import jmTableList from '@/components/data/tableList';
import { jmDictSelect } from '@/components/tool';
import { filterVisible } from '@/utils/utils';
import jmFormOptions from '@/components/data/formOptions';
// 搜索项结构
const searchStructure = [
  {
    visible: 'link_creater',
    field: 'link_creater',
    label: '关联创建人',
    placeholder: '关联创建人',
    component: 'dict',
    type: 'dataset',
    dict: 'student',
    name: 'linkCreater',
    clearable: true,
    column: [24, 12, 8, 8]
  },
  {
    visible: 'act_action',
    field: 'act_action',
    label: '用户行为设置',
    placeholder: '用户行为设置',
    component: 'mgSelect',
    multiple: true,
    constKey: 'act_action',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'act_creater',
    field: 'act_creater',
    label: '创建人绑定',
    placeholder: '创建人绑定',
    component: 'mgSelect',
    multiple: true,
    constKey: 'act_creater',
    column: [24, 12, 8, 8]
  }
];
// options
const options = {};
// 搜索数据结构
const searchData = {
  id: '',
  link_creater: '',
  isSearch: false,
  act_action: '',
  act_creater: ''
};

export default {
  components: {
    BiDPie, BiBarLine, jmTableList, jmDictSelect, jmFormOptions
  },
  data() {
    return {
      tableListInited: false,
      size: 'small',
      searchStructure,
      options,
      searchData: {},
      currentPage: 1,
      createrData: {},
      actionData: {
        options: {
        },
        refresh: 1
      }
    };
  },
  methods: {
    filterVisible,
    // 初始默认搜索值
    setSearchData() {
      this.searchData = Object.assign({}, searchData);
    },
    getSearch() {
      this.currentPage = 1;
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
    },
    // 创建人占比
    getCreater() {
      this.fetchData({
        url: '/index/b_i_action_group/createrPie',
        field: 'createrData',
        param: this.searchData,
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 30
          },
          colors: [
            '#409EFF', '#BD48FF', '#FF9F00', '#FF6153', '#01E2FF', '#FF90A8',
            '#00E9A8', '#F83458', '#8103FF', '#65F9E3', '#FFC800', '#273EF0',
            '#F7B3F6'
          ],
          labelWidthPercent: 100 / 3
        }
      });
    },
    // 创建人及用户行为趋势
    getActionData() {
      this.fetchData({
        url: '/index/b_i_action_group/getLine',
        field: 'actionData',
        param: this.searchData,
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 0
          },
          labelWidthPercent: 100 / 3,
          colors: [
            '#409EFF', '#BD48FF', '#FF9F00', '#FF6153', '#01E2FF', '#FF90A8',
            '#00E9A8', '#F83458', '#8103FF', '#65F9E3', '#FFC800', '#273EF0',
            '#F7B3F6'
          ],
          barWidth: 'auto',
          domainType: 'string',
          groupType: true
        }
      });
    },
    getResourceTag(lv) {
      let type = '';
      switch (lv) {
        case 65:
          type = 'danger';
          break;
        case 57:
          type = 'success';
          break;
        case 53:
          type = 'warning';
          break;
        default:
          type = 'info';
          break;
      }
      return type;
    }
  },
  created() {
    this.setSearchData();
    this.searchData.id = this.$route.params.id;
    // 因为默认查询字段为空，初始设置查询数据字段
    this.$http
      ._get({
        url: `/index/b_i_action_group/showUser?id=${this.$route.params.id}`
      })
      .then(({ data }) => {
        this.options = data.const_dict;
        this.getCreater();
        this.getActionData();
      }, ({ data }) => {
        if (!data.const_dict) {
          this.$alert('数据问题', '', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.push({ name: 'actionGroupDataList', params: { id: this.$route.params.id } });
            }
          });
        }
      });
  },
  watch: {},
  mixins: [student, common]
};
</script>
<style>
  .el-form {
    margin-top: 20px;
  }
  .offer.manage .operation {
    padding-bottom: 1em;
    text-align: center;
  }
  .offer.manage .options .el-form-item {
    display: -webkit-flex;
    display: flex;
    margin-bottom: 10px;
  }

  .offer.manage .options .el-form-item__label {
    min-width: 7em;
    padding-right: 8px;
  }
  .offer.manage .options .el-form-item__content {
    -webkit-flex: 1;
    flex: 1;
  }
  .offer.manage .options .el-date-editor--daterange.el-input,
  .offer.manage .options .el-date-editor--daterange.el-input__inner,
  .offer.manage .options .el-date-editor--timerange.el-input,
  .offer.manage .options .el-date-editor--timerange.el-input__inner {
    width: 100%;
    white-space: nowrap;
  }
  .s_right {
    float: right;
  }

  .rows:last-child {
    /*margin-bottom: 200px;*/
  }

  .rows .rows-div {
    background-color: #FFF;
    border-radius: 5px;
    margin-top: 10px;
    padding: 10px 20px 20px 20px;
  }

  .rows .rows-div p {
    border-bottom: solid 1px #CCC;
    padding: 10px 0px;
  }

  .rows .rows-div .map-div {
    height: 920px;
  }

  .rows .rows-div .h-div {
    height: 595px;
  }

  .rows .rows-div .chart-div {
    height: 250px;
  }

  .s_title {
    font-size: 18px;
  }
</style>
